/** Next successful login lands on appreciation screen first (anti-reopen-loop). Cleared after that screen */
export const UNIFIED_INTAKE_JUST_COMPLETED_KEY = "unified_intake_just_completed";

export const ALWAYS_REOPEN_FORM_TYPES = ["questionnaires_send_to_patient", "emr_history"];

export function unifiedManifestRowIsAlwaysReopen(item) {
  if (!item || typeof item !== "object") return false;
  if (item.type === "questionnaire" && ALWAYS_REOPEN_FORM_TYPES.includes("questionnaires_send_to_patient")) {
    return true;
  }
  if (item.type === "patient_form" && item.step === "emr_history" && ALWAYS_REOPEN_FORM_TYPES.includes("emr_history")) {
    return true;
  }
  return false;
}

/** Mirrors patient-field semantics used for partial-resume filtering (truthy flags = still needing patient action per API). */
export function patientPayloadShowsStepIncomplete(resp, step) {
  if (!resp || !step) return false;
  if (step === "patient_demographics_verification") {
    const flagged = resp.patient_demographics_verification === 1 || resp.patient_demographics_verification === "1";
    return !!(flagged && !resp.demographics_verified_at);
  }
  if (step === "new_patient_intake_form") {
    return resp.new_patient_intake_form === 1 || resp.new_patient_intake_form === "1";
  }
  const v = resp[step];
  return v === 1 || v === "1" || v === true;
}

/**
 * Scenario 2 queue: questionnaires + EMR always; other manifest patient_form rows only while still incomplete on packet.
 * Returns rows with __backendStepIndex renumbered 0..n-1 for step-complete payloads.
 *
 * @param {Array<object>} manifestFromApi
 * @param {object|null} patientFormResponse — getPatientFormsById payload
 */
export function buildReentryUnifiedDisplayManifest(manifestFromApi, patientFormResponse) {
  const annotated = (manifestFromApi || []).map((item, backendStepIndex) => ({
    ...item,
    __backendStepIndex: backendStepIndex,
  }));
  const kept = annotated.filter((row) => {
    if (row.type === "questionnaire") return true;
    if (row.type === "patient_form" && row.step === "emr_history") return true;
    if (row.type === "patient_form" && row.step) {
      return patientPayloadShowsStepIncomplete(patientFormResponse, row.step);
    }
    return false;
  });
  return kept.map((row, i) => ({ ...row, __backendStepIndex: i }));
}

export function peekUnifiedIntakeJustCompleted() {
  try {
    return typeof sessionStorage !== "undefined" && sessionStorage.getItem(UNIFIED_INTAKE_JUST_COMPLETED_KEY) === "1";
  } catch {
    return false;
  }
}

export function setUnifiedIntakeJustCompleted() {
  try {
    if (typeof sessionStorage !== "undefined") sessionStorage.setItem(UNIFIED_INTAKE_JUST_COMPLETED_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function clearUnifiedIntakeJustCompleted() {
  try {
    if (typeof sessionStorage !== "undefined") sessionStorage.removeItem(UNIFIED_INTAKE_JUST_COMPLETED_KEY);
  } catch {
    /* ignore */
  }
}
